import Snackbar from '@mui/material/Snackbar'

import { SnackbarType } from '$/types'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import {
  closeSnackbar,
  openNewAssessmentCompletedSnackbar,
  openNewSavedStatesDontMatchSystemScopeRoutesSnackbar
} from 'app/entities/store/snackbarSlice'
import { selectSnackbar } from 'app/entities/store/snackbarsSelectors'

import SavedStateDontMatchSystemScopeRoutes from 'common/components/Snackbars/SavedStateDontMatchSystemScopeRoutes'
import NewAssessmentCompleted from 'common/components/Snackbars/NewAssessmentCompleted'

const Snackbars = () => {
  const dispatch = useAppDispatch()
  const snackbar = useAppSelector(selectSnackbar)

  const typesToComponents: Record<string, React.FC<SnackbarType>> = {
    [openNewSavedStatesDontMatchSystemScopeRoutesSnackbar.type]:
      SavedStateDontMatchSystemScopeRoutes,
    [openNewAssessmentCompletedSnackbar.type]: NewAssessmentCompleted
  }

  const close = () => {
    dispatch(closeSnackbar())
  }

  const Component =
    snackbar && Object.keys(typesToComponents).includes(snackbar.id)
      ? typesToComponents[snackbar.id]
      : null

  return (
    Component && (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={true}
        className='w-[44%]'
      >
        <div className='flex justify-center w-full'>
          <Component onClose={close} />
        </div>
      </Snackbar>
    )
  )
}

export default Snackbars
